/*
 * File: index.tsx
 * Desc: 可编辑表格输入搜索组件
 * File Created: 2019-12-05 17:13:33
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useEffect, useRef } from 'react';
import { debounce } from 'lodash';
import { AutoComplete } from 'antd';
import { FormInputSearchTableConfig } from '../input-search-table';
import { InputSearchTable } from '..';

interface TdAutoRenderProps {
    fetchApi?: Function;
    apiParamsCb?: (value: any) => any;
    optionRender?: (data: any) => any;
    onSelect?: (value: any, option: any) => void;
    onChange?: (value: string) => void;
    style?: React.CSSProperties;
    className?: string;
    value?: any;
    placeholder?: string;
    /** 下拉表格配置 */
    tableConfig?: FormInputSearchTableConfig;
}

/** 可编辑表格输入搜索组件 */
const TdAutoRender = (props: TdAutoRenderProps) => {
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState<any>();
    const tableRef = useRef<any>();

    const onSearch = debounce(function(value: string) {
        props.tableConfig && openTable();
        value &&
            props.fetchApi &&
            props
                .fetchApi(props.apiParamsCb ? props.apiParamsCb(value) : value)
                .then((res: any) => {
                    setOptions(
                        res.map((data: any) => (
                            <AutoComplete.Option
                                key={data.key || data.value}
                                value={data.value}
                                {...{ data }}
                            >
                                {props.optionRender ? props.optionRender(data) : data.value}
                            </AutoComplete.Option>
                        ))
                    );
                });
    }, 500);

    function onSelect(value: any, option: any) {
        props.onSelect && props.onSelect(value, option);
        setInputValue(value);
    }

    function onChange(value: any) {
        setInputValue(value);
        !props.tableConfig && props.onChange && props.onChange(value);
    }

    function onRowCB(normalizeValue: any, record: any, inputValue: number | string | null) {
        if (inputValue) setInputValue(inputValue);
        props.onChange && props.onChange(normalizeValue ? normalizeValue(record) : record);
    }

    function openTable() {
        tableRef.current.setTableVisible(true);
    }

    useEffect(() => {
        props.value && setInputValue(props.value);
    }, [props.value]);

    return (
        <div style={{ position: 'relative' }}>
            <AutoComplete
                className={props.className}
                style={props.style}
                onSelect={onSelect}
                onSearch={onSearch}
                onChange={onChange}
                placeholder={props.placeholder || '请输入值'}
                value={inputValue}
            >
                {options}
            </AutoComplete>
            {props.tableConfig && (
                <InputSearchTable
                    onRowCB={onRowCB}
                    inputValue={inputValue}
                    tableConfig={{ ...props.tableConfig }}
                    ref={tableRef}
                />
            )}
        </div>
    );
};

export default TdAutoRender;
